import { render, staticRenderFns } from "./commercial-proposal-show.vue?vue&type=template&id=e36bfa5a&scoped=true&"
import script from "./commercial-proposal-show.vue?vue&type=script&lang=js&"
export * from "./commercial-proposal-show.vue?vue&type=script&lang=js&"
import style0 from "./commercial-proposal-show.vue?vue&type=style&index=0&id=e36bfa5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36bfa5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e36bfa5a')) {
      api.createRecord('e36bfa5a', component.options)
    } else {
      api.reload('e36bfa5a', component.options)
    }
    module.hot.accept("./commercial-proposal-show.vue?vue&type=template&id=e36bfa5a&scoped=true&", function () {
      api.rerender('e36bfa5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/proposals/commercial-proposal-show.vue"
export default component.exports